import React from 'react';
import { IoMdClose } from "react-icons/io";
import { useTr } from '../lib/i18n';
import { CITY_RU } from '../lib/ru';

const GarageFiltersModal = ({
    onClose,
    locations,
    sectors,
    location,
    setLocation,
    sector,
    setSector,
    minPrice,
    setMinPrice,
    maxPrice,
    setMaxPrice,
    minSurface,
    setMinSurface,
    maxSurface,
    setMaxSurface
}) => {
const tr = useTr();
const lang = tr('ro', 'ru');

    const resetFilters = () => {
        setMinSurface('');
        setMaxSurface('');
        setMinPrice('');
        setMaxPrice('');
        setLocation('');
        setSector('');
    };

    return (
        <>
            <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/60" onClick={onClose} style={{ cursor: "url('/cursors/cross.cur') 6 6, pointer" }}>
                <div
                    className="w-full max-w-[400px] max-h-[90vh] bg-white rounded-[5px] flex flex-col overflow-hidden cursor-default"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="flex justify-end p-[10px] border-b border-gray-200 shrink-0">
                        <IoMdClose
                            onClick={onClose}
                            className="text-3xl bg-gray-300 rounded-full p-[5px] hover:bg-black hover:text-white transition-all duration-100 ease-in cursor-pointer"
                        />
                    </div>

                    <div className="overflow-y-auto px-[30px] pt-[20px] pb-[10px] flex flex-col gap-[15px]">

                        {/* Suprafața */}
                        <div className="flex flex-col w-full gap-[5px]">
                            <p className='text-[14px] font-poppins font-[500]'>{tr('Suprafața - m²', 'Площадь - м²')}</p>
                            <div className="flex justify-between gap-[10px] flex-wrap">
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    placeholder={tr('De la', 'От')}
                                    value={minSurface}
                                    onChange={(e) => setMinSurface(e.target.value.replace(/\D/g, ''))}
                                    className="font-body px-[12px] py-[6px] rounded-[5px] outline-none border-[1px] border-gray-300 max-w-[47%] flex-grow"
                                />
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    placeholder={tr('Până la', 'До')}
                                    value={maxSurface}
                                    onChange={(e) => setMaxSurface(e.target.value.replace(/\D/g, ''))}
                                    className="font-body px-[12px] py-[6px] rounded-[5px] outline-none border-[1px] border-gray-300 max-w-[47%] flex-grow"
                                />
                            </div>
                        </div>

                        {/* Preț */}
                        <div className="flex flex-col w-full gap-[5px]">
                            <p className='text-[14px] font-poppins font-[500]'>{tr('Preț - €', 'Цена - €')}</p>
                            <div className="flex justify-between gap-[10px] flex-wrap">
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    placeholder={tr('De la', 'От')}
                                    value={minPrice}
                                    onChange={(e) => setMinPrice(e.target.value.replace(/\D/g, ''))}
                                    className="font-body px-[12px] py-[6px] rounded-[5px] outline-none border-[1px] border-gray-300 max-w-[47%] flex-grow"
                                />
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    placeholder={tr('Până la', 'До')}
                                    value={maxPrice}
                                    onChange={(e) => setMaxPrice(e.target.value.replace(/\D/g, ''))}
                                    className="font-body px-[12px] py-[6px] rounded-[5px] outline-none border-[1px] border-gray-300 max-w-[47%] flex-grow"
                                />
                            </div>
                        </div>

                        {/* Locație */}
                        <div className="flex flex-col gap-[5px] w-full w-1/2">
                            <p className='text-[14px] font-poppins font-[500]'>{tr('Locație', 'Локация')}</p>
                            <select
                                name="locationSector"
                                id="locationSector"
                                className="font-body px-[24px] py-[10px] text-[#181616] rounded-[5px] outline-none border-[1px] border-gray-300 text-[17px]"
                                value={
                                    sector ? `sector-${sector}` :
                                        location ? `location-${location}` :
                                            ''
                                }
                                onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    if (selectedValue.startsWith('sector-')) {
                                        const slug = selectedValue.replace('sector-', '');
                                        setLocation('chisinau');
                                        setSector(slug);
                                    } else if (selectedValue.startsWith('location-')) {
                                        const slug = selectedValue.replace('location-', '');
                                        setLocation(slug);
                                        setSector('');
                                    } else {
                                        setLocation('');
                                        setSector('');
                                    }
                                }}
                            >
                                <option value="">{tr('Locație', 'Локация')}</option>
                                <optgroup label={tr('Chișinău', 'Кишинёв')}>
                                    {sectors.map((sector) => (
                                        <option key={`sector-${sector.id}`} value={`sector-${sector.slug}`}>
                                            {sector.sector}
                                        </option>
                                    ))}
                                </optgroup>
                                <optgroup label={tr('Altele', 'Другие')}>
                                    {locations.filter((loc) => loc.id !== 1).map((loc) => (
                                        <option key={`location-${loc.id}`} value={`location-${loc.slug}`}>
                                            {lang === 'ru' ? (CITY_RU[loc.slug]?.name || loc.location) : loc.location}
                                        </option>
                                    ))}
                                </optgroup>
                            </select>
                        </div>
                    </div>

                    {/* Reset button */}
                    <div className="w-full border-t border-gray-300 flex justify-center shrink-0">
                        <button
                            className="font-body font-[500] text-[#181616] hover:text-gray-600 cursor-pointer transition-all duration-100 ease-in my-[20px]"
                            onClick={resetFilters}
                        >
                            Șterge filtrele
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default GarageFiltersModal;